module.exports = __webpack_public_path__ + "img/assinatura.c6b8c363.svg";